let sessionLang = sessionStorage.getItem('language')
let defaultLang = navigator.language.indexOf('zh') !== -1 ? 'zh' : 'en'

const query = location.search.substr(1);
const queryArr = query.split('&')
let queryObj = {};
queryArr.map(item=>{
  queryObj[item.split('=')[0]] = item.split('=')[1]
})
let lang = sessionLang !== null
  ? sessionLang : queryObj['locale']
    ? queryObj['locale'] : defaultLang

export default lang
